import { useMediaQuery } from "react-responsive";

const useMediaQueryHook = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isLargeScreen = useMediaQuery({ minWidth: 1024, maxWidth: 1400 });
  return { isMobile, isTablet, isLargeScreen };
};

export default useMediaQueryHook;
